var map = {
	"./abaddon.png": 9404,
	"./abyssal_underlord.png": 9324,
	"./alchemist.png": 5045,
	"./ancient_apparition.png": 1077,
	"./antimage.png": 6199,
	"./arc_warden.png": 9365,
	"./axe.png": 8857,
	"./bane.png": 61,
	"./batrider.png": 2410,
	"./beastmaster.png": 2046,
	"./bloodseeker.png": 4528,
	"./bounty_hunter.png": 3375,
	"./brewmaster.png": 4567,
	"./bristleback.png": 1417,
	"./broodmother.png": 1934,
	"./centaur.png": 927,
	"./chaos_knight.png": 2041,
	"./chen.png": 3053,
	"./clinkz.png": 2346,
	"./crystal_maiden.png": 9220,
	"./dark_seer.png": 483,
	"./dark_willow.png": 5696,
	"./dawnbreaker.png": 8119,
	"./dazzle.png": 4933,
	"./death_prophet.png": 2724,
	"./disruptor.png": 6557,
	"./doom_bringer.png": 4078,
	"./dragon_knight.png": 4954,
	"./drow_ranger.png": 7426,
	"./earth_spirit.png": 5237,
	"./earthshaker.png": 6157,
	"./elder_titan.png": 906,
	"./ember_spirit.png": 7678,
	"./enchantress.png": 1447,
	"./enigma.png": 2822,
	"./faceless_void.png": 8952,
	"./furion.png": 2802,
	"./grimstroke.png": 4176,
	"./gyrocopter.png": 7927,
	"./hoodwink.png": 4354,
	"./huskar.png": 7743,
	"./invoker.png": 6719,
	"./jakiro.png": 1803,
	"./juggernaut.png": 8833,
	"./keeper_of_the_light.png": 9954,
	"./kez.png": 8223,
	"./kunkka.png": 6156,
	"./legion_commander.png": 2744,
	"./leshrac.png": 6299,
	"./lich.png": 2297,
	"./life_stealer.png": 4122,
	"./lina.png": 859,
	"./lion.png": 2291,
	"./lone_druid.png": 604,
	"./luna.png": 8055,
	"./lycan.png": 2532,
	"./magnataur.png": 3319,
	"./marci.png": 8133,
	"./mars.png": 8022,
	"./medusa.png": 3990,
	"./meepo.png": 7061,
	"./mirana.png": 2755,
	"./monkey_king.png": 5866,
	"./morphling.png": 655,
	"./muerta.png": 7711,
	"./naga_siren.png": 3524,
	"./necrolyte.png": 7314,
	"./nevermore.png": 7176,
	"./night_stalker.png": 9965,
	"./nyx_assassin.png": 7214,
	"./obsidian_destroyer.png": 5776,
	"./ogre_magi.png": 1471,
	"./omniknight.png": 2493,
	"./oracle.png": 543,
	"./pangolier.png": 5890,
	"./phantom_assassin.png": 8336,
	"./phantom_lancer.png": 5910,
	"./phoenix.png": 7076,
	"./primal_beast.png": 806,
	"./puck.png": 866,
	"./pudge.png": 594,
	"./pugna.png": 4938,
	"./queenofpain.png": 4288,
	"./rattletrap.png": 9230,
	"./razor.png": 6497,
	"./riki.png": 7838,
	"./ringmaster.png": 1749,
	"./rubick.png": 2687,
	"./sand_king.png": 3417,
	"./shadow_demon.png": 21,
	"./shadow_shaman.png": 5260,
	"./shredder.png": 430,
	"./silencer.png": 8704,
	"./skeleton_king.png": 8656,
	"./skywrath_mage.png": 6183,
	"./slardar.png": 3772,
	"./slark.png": 846,
	"./snapfire.png": 5809,
	"./sniper.png": 5316,
	"./spectre.png": 809,
	"./spirit_breaker.png": 5191,
	"./storm_spirit.png": 3296,
	"./sven.png": 415,
	"./techies.png": 196,
	"./templar_assassin.png": 164,
	"./terrorblade.png": 2357,
	"./tidehunter.png": 7427,
	"./tinker.png": 4400,
	"./tiny.png": 2635,
	"./treant.png": 9639,
	"./troll_warlord.png": 2478,
	"./tusk.png": 4494,
	"./undying.png": 1765,
	"./ursa.png": 3780,
	"./vengefulspirit.png": 3686,
	"./venomancer.png": 9853,
	"./viper.png": 4869,
	"./visage.png": 7418,
	"./void_spirit.png": 4067,
	"./warlock.png": 370,
	"./weaver.png": 5025,
	"./windrunner.png": 1905,
	"./winter_wyvern.png": 2384,
	"./wisp.png": 6932,
	"./witch_doctor.png": 3208,
	"./zuus.png": 2514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5997;